import { useTranslation } from "react-i18next";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getOptionByName, // [crm-iso]
  getPropertyOptions,
  updateOptions,
} from "apis/option";
import { useAntdMessage } from "hooks/useAntdMessage";

export function usePropertyOption(options = {}) {
  const { message } = useAntdMessage();
  const { t } = useTranslation();
  return useQuery({
    queryKey: ["propertyOption"],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getPropertyOptions();
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    throwOnError: (error) => {
      return message.error(
        error.message || t("error.failed_to_load_data_from_server")
      );
    },
    ...options,
  });
}

// Query untuk update options
export const useEditOptions = () => {
  return useMutation({
    mutationFn: updateOptions,
  });
};

// [crm-iso] START — Ambil satu option berdasarkan nama (mis. crm_iso_setting)
export function useOptionByName(name, options = {}) {
  const { message } = useAntdMessage();
  const { t } = useTranslation();
  return useQuery({
    queryKey: ["option", name],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getOptionByName(name);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    throwOnError: (error) => {
      return message.error(
        error.message || t("error.failed_to_load_data_from_server")
      );
    },
    ...options,
  });
}
// [crm-iso] END
